<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- Stage Name -->
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Stage Name</mat-label>
      <input formControlName="stageName" matInput placeholder="Stage Name" type="text" [value]="stageName">
      <mat-error *ngIf="inputForm.controls['stageName'].hasError('required')">
        Stage Name is required!
      </mat-error>
      <mat-error *ngIf="inputForm.controls['stageName'].hasError('pattern')">
        Stage Name can't contain any of the following characters : \ / : * ? " < > |
      </mat-error>
    </mat-form-field>
  </div>

</form>
